module.exports = __webpack_public_path__ + "img/nishihara-kiyokazu-sensei.87636f60.jpg";